import { RadioButton, RadioGroup, Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { isStartPlacementAtom, showArrowsAtom } from '@/atoms/visualisation';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';

export const PitchMarkerPlacementToggle = () => {
  const { t } = useTranslation('visualisation');
  const isStartPlacement = useAtomValue(isStartPlacementAtom);
  const showArrows = useAtomValue(showArrowsAtom);

  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-marker-placement" groupTitle={t('markerPlacement.title')} size="regular">
      <Typography variant="bodySmall">{t('markerPlacement.description')}</Typography>
      <RadioButton
        checked={isStartPlacement}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.IS_START_PLACEMENT, 'true')}
        id="marker-placement-start-option"
        label={t('markerPlacement.start')}
        value="true"
        size="small"
        disabled={showArrows}
      />
      <RadioButton
        checked={!isStartPlacement}
        onChange={() => setQueryParams(ConfigDisplaySettingKey.IS_START_PLACEMENT, 'false')}
        id="marker-placement-end-option"
        label={t('markerPlacement.end')}
        value="false"
        size="small"
        disabled={showArrows}
      />
    </RadioGroup>
  );
};
